// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Audit from "@material-ui/icons/TrackChanges";
import Landing from "@material-ui/icons/FlightLandOutlined";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import AirlinesPassengerPage from "views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";
import OutstandingSettlementPage from "views/OutstandingSettlement/Index.jsx";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"


const dashboardRoutes = [
    {
        path: "/main-landing",
        sidebarName: "Main Landing",
        navbarName: "Main Landing",
        icon: Landing,
        component: MainLandingPage,
        subMenu: [],
    },
    {
        path: "/app/passenger-data",
        sidebarName: "Passenger Data",
        navbarName: "Airline Passenger Data",
        icon: Passenger,
        subMenu: [],
        component: AirlinesPassengerPage
    },
    {
        path: "/app/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
        path: "/app/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    {
        path: "/app/outstanding-settlement",
        sidebarName: "Outstanding Settlement",
        navbarName: "Outstanding Settlement",
        icon: Settlement,
          subMenu: [],
          component: OutstandingSettlementPage
      },
      {
        path: "/app/psc-regional/help-center",
        sidebarName: "Help Center",
        navbarName: "Help Center",
        icon: HelpIcon,
        component: HelpCenter,
        subMenu: []
      },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/supervisor.jsx